'use strict';

/* InViewNew adds functions to elements when scrolled into view
To use: Extend "InViewNew" in your page JS. Attach data-in-view-new to elements you want to watch.
  
  Options:
    root:
      The element that is used as the viewport for checking visiblity of the target.
      Must be the ancestor of the target.
      Defaults to the browser viewport if not specified or if null.

    rootMargin:
      Margin around the root.
      Can have values similar to the CSS margin property, e.g. "10px 20px 30px 40px" (top, right, bottom, left). The values can be percentages.
      This set of values serves to grow or shrink each side of the root element's bounding box before computing intersections.
      Defaults to all zeros.

    threshold:
      Either a single number or an array of numbers which indicate at what percentage of the target's visibility the observer's callback should be executed.
      If you only want to detect when visibility passes the 50% mark, you can use a value of 0.5.
      If you want the callback to run every time visibility passes another 25%, you would specify the array [0, 0.25, 0.5, 0.75, 1].
      A value of 1.0 means that the threshold isn't considered passed until every pixel is visible.
      Defaults to 0.5.

For more info go to https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

TODO: replace old InView class with this one
*/

function InViewNew() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout];

  this.target = '[data-in-view-new]';
  this.root = null;
  this.rootMargin = '0px';
  this.threshold = 0.5;

  this.init = function () {};

  this.initAllReady = function () {
    if (window.IntersectionObserver) {
      this.isInView(this.target);
    } else {
      document.querySelectorAll(this.target).forEach(function (item) {
        return item.classList.add('in-view');
      });
    }
  };

  this.isInView = function (target) {
    var pageTargets = document.querySelectorAll(target);

    var options = {
      root: _this.root,
      rootMargin: _this.rootMargin,
      threshold: _this.threshold
    };

    var callback = function callback(entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
        }
      });
    };

    var observer = new IntersectionObserver(callback, options);

    pageTargets.forEach(function (item) {
      observer.observe(item);
    });
  };
}